import React from 'react';
import CustomImage from '../../../components/custom-image';

const Copper = () => {
  return (
    <div className="card">
      <div className="title">
        <div className="icon">
          <CustomImage className="custom-image" imageName="icon-copper-lg.png" alt="Copper" maxWidth="90" />
        </div>
        <div className="text">
          <h4>Copper</h4>
        </div>
      </div>
      <div className="middle-text">
        <p>
          One of the largest
          <br /> copper producers in
          <br /> India
        </p>
      </div>
      <div className="bottom-text">
        <p>EBITDA (In INR Cr.)</p>
        <p className="text-p">Tuticorin smelter and refinery currently not operational</p>
      </div>
    </div>
  );
};

export default Copper;
